import Header from './components/Header';
import Hero from './components/Hero';
import AppSection from './components/AppSection';
import TopicsSection from './components/TopicsSection';
import CardsSection from './components/CardsSection';
import UpdatesSection from './components/UpdatesSection';
import FaqSection from './components/FaqSection';
import RankingSection from './components/RankingSection';
import FeaturesSection from './components/FeaturesSection';
import AboutSection from './components/AboutSection';
import ContactSection from './components/ContactSection';
import CommentsSection from './components/CommentsSection';
import MediaSection from './components/MediaSection';
import CarouselSection from './components/CarouselSection';
import IndexSection from './components/IndexSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <AppSection />
        <TopicsSection />
        <CardsSection />
        <UpdatesSection />
        <FaqSection />
        <RankingSection />
        <FeaturesSection />
        <AboutSection />
        <ContactSection />
        <CommentsSection />
        <MediaSection />
        <CarouselSection />
        <IndexSection />
      </main>
      <Footer />
    </>
  );
}